export default function SkeletonBone({ className = '', rounded = 'rounded-md' }) {
  return (
    <span
      aria-hidden="true"
      className={['skeleton-bone block', rounded, className].filter(Boolean).join(' ')}
    />
  );
}
